import { render, staticRenderFns } from "./Estudios.vue?vue&type=template&id=56002d05&lang=html&"
import script from "./Estudios.vue?vue&type=script&lang=js&"
export * from "./Estudios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports